import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject, Observable, Subject, of } from "rxjs";
import { map, shareReplay, switchMap, take, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { DisplayDetailsModalComponent } from '../core/modals/display-details/display-details.component';
import { LogCategory, LogService, LogType, LoggerService } from '../core/services/logger.service';
import { UtilityService } from '../core/services/utility.service';
import { ToastrService } from 'ngx-toastr';

//  Validation for the old request object
export function validate() {       
    this.errorArray = [];
    this.isValid = true;
    
    if ((this.HostUniversity == '') || (!!!this.HostUniversity)) {        
        this.errorArray.push({ stage: 0, text: "Host University is missing"});
        this.isValid = false;
    }
    if ((this.HostUniversity == 'other') && ((this.otherHostUniversity == '') || (!!!this.otherHostUniversity))) {        
        this.errorArray.push({ stage: 0, text: "You have selected 'Other' for Host University but not entered a university name" });
        this.isValid = false;
    }
    if ((this.Term == '') || (!!!this.Term)) {       
        this.errorArray.push({ stage: 0, text: "Term is missing" });
        this.isValid = false;
    }    
    if ((this.HostCourseNumber == '') || (!!!this.HostCourseNumber) ) {       
        this.errorArray.push({ stage: 1, text: "Course Number is missing" });
        this.isValid = false;
    }
    if ((this.HostCourseName == '') || (!!!this.HostCourseName)) {
        this.errorArray.push({ stage: 1, text: "Course Name is missing" });
        this.isValid = false;
    }
    if ((this.HostCreditHours == '') || (!!!this.HostCreditHours)) {
        this.errorArray.push({ stage: 1, text: "Course Credits are missing" });
        this.isValid = false;
    }
    if ((this.SyllabusFilename == '') || (!!!this.SyllabusFilename)) {        
        this.errorArray.push({ stage: 1, text: "You have not uploaded the syllabus" });
        this.isValid = false;
    }
    if ((this.UncCourse == '') || (!!!this.UncCourse)) {       
        this.errorArray.push({ stage: 2, text: "UNC Equivalent is missing" });
        this.isValid = false;
    }
    if ((this.UncCourse == 'other') && ( (this.otherUncCourse == '') || (!!!this.otherUncCourse)) ) {        
        this.errorArray.push({ stage: 2, text: "You have selected 'Other' for UNC Course but not entered a course name" });
        this.isValid = false;
    }
    if ((this.UncCourseHours == '') || (!!!this.UncCourseHours)) {        
        this.errorArray.push({ stage: 2, text: "UNC Requested Credits is missing" });
        this.isValid = false;
    }
    if ((this.UncCourse == 'General Education') && ((this.GeRequirement == '') || (!!!this.GeRequirement) )) {        
        this.errorArray.push({ stage: 2, text: "General Education Type is missing" });
        this.isValid = false;
    }    
    if ((this.HasEmphasis) && ((this.AreaOfEmphasis == '') || (!!!this.AreaOfEmphasis))) {       
        this.errorArray.push({ stage: 3, text: "Emphasis Area is missing" });
        this.isValid = false;
    }
    if ((this.HasEmphasis) && ((this.UncEquivalentToSubstitute == '') || (!!!this.UncEquivalentToSubstitute))) {      
        this.errorArray.push({ stage: 3, text: "AOE Equivalent Course is missing" });
        this.isValid = false;
    }
    if ((this.HasEmphasis) && ((this.AnticipatedGraduation == '') || (!!!this.AnticipatedGraduation))) {      
        this.errorArray.push({ stage: 3, text: "Anticipated Graduation date is missing" });
        this.isValid = false;
    }
    if ((this.HasEmphasis) && ((this.AoeJustification == '') || (!!!this.AoeJustification))) {       
        this.errorArray.push({ stage: 3, text: "Justification is missing" });
        this.isValid = false;
    }
}

@Injectable({
  providedIn: 'root'
})
export class TransferCreditsService {
    public readonly V2020_BASE_TABLE = 'STUDENT_BSBA_EXCHANGE_COURSE_APPROVAL';
    public readonly V2025_BASE_TABLE = 'STUDENT_BSBA_EXCHANGE_REQUEST';
    private readonly API_URL: string = environment.apiUrl + '/transfercredits';

    public refreshSubject$: BehaviorSubject<boolean> = new BehaviorSubject(false); //use this to force a refetch of myRequests

    //  Doesn't seem to be used
    //public request$: BehaviorSubject<number> = new BehaviorSubject(0);
    //public filteredCourses$: BehaviorSubject<any> = new BehaviorSubject([]);

    //  Deprecated - used in program finder
    //public programSearch$: BehaviorSubject<string[]> = new BehaviorSubject([]);

   
    //  These seem to only used in the old submission form.  Can be deleted once the old form is retired.
    public saveStatus$: Subject<string> = new Subject();
    public university$: BehaviorSubject<string> = new BehaviorSubject('');
    public hasSaveError: boolean;

    private httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json',
        })
    };

    constructor(
        private http: HttpClient,        
        private logger: LoggerService,
        private utility: UtilityService,
        private modalService: NgbModal,
        private toastr: ToastrService,
    ) {
        this.log("constructor", null, LogCategory.Constructor);
    }
    private log(method: string = null, message = null, category: LogCategory = LogCategory.Default): void {
        method = (method) ? '.' + method + '()' : '';
        message = (message) ? message.toString() : '';
        this.logger.try(this.constructor.name + method + ': ' + message, LogType.Service, LogService.TransferCredits, category);
    }

   
    // All the requests for the current user
    public myRequests$: Observable<any[]> = this.refreshSubject$.pipe(
        switchMap(() => this.http.get<any>(this.API_URL + '/self')),
        tap((data: any[]) => {
                this.log('myRequests', 'Fetched all requests for current user', LogCategory.SubscriptionData);
            }),
        shareReplay(1)
    );

    //#region Old Form - Can be deleted once the old form is retired.
    // Get a request to allow the user to update
    public fetchMyRequest$(requestId: number): Observable<any> {
        var url = `${this.API_URL}/${requestId}`
        return this.http.get<any>(url).pipe(
            tap(() => {
                this.log('myRequest', 'Fetched request for current user', LogCategory.SubscriptionData);
            }),
            map(dbRequest => {
                dbRequest.validate = validate;
                dbRequest.validate();
                return dbRequest;
            }),
            shareReplay(1)
        );

    }
    //  Only used in the old submission form.  Can be deleted once the old form is retired.
    public approvedClasses$: Observable<any> = this.university$
        .pipe(
            switchMap(university => {
                var url = `${this.API_URL}/approved-classes`
                return this.http.get<any>(`${url}?university=${encodeURIComponent(university)}`)
                    .pipe(
                        tap((data: any[]) => {
                            this.log('approvedClasses', 'Fetched all approved classes for university', LogCategory.SubscriptionData);
                        }),
                    );
            }),
            shareReplay(1)
        );

    //#endregion

    //#region Used in Program Finder - Can be deleted once those items are removed

    //public matchedPrograms$: Observable<any> = this.programSearch$
    //    .pipe(
    //        switchMap(courses => {
    //            var url = `${this.transferCreditsApiUrl}/matchprograms`
    //            return this.http.post<any>(url, JSON.stringify(courses), this.httpOptions).pipe(
    //                tap((data: any[]) => {
    //                    this.log('matchedPrograms', 'Fetched matched programs for courses', LogCategory.SubscriptionData);
    //                }),
    //                shareReplay(1)
    //            );
    //        })
    //    )

    //public copyRequest$(id: number): Observable<any> {

    //    var url = `${this.transferCreditsApiUrl}/${id}/copy`;
    //    return this.http.put(url, id, this.httpOptions).pipe(
    //        tap(() => {
    //            this.log('copyRequest', 'Copied request for current user', LogCategory.SubscriptionData);
    //        }),
    //        map((dbRequest:any) => {
    //            dbRequest.validate = validate;
    //            dbRequest.validate();
    //            return dbRequest;
    //        }),
    //        shareReplay(1)
    //    );    ;
    //}
    //#endregion

    public courseId$: BehaviorSubject<number> = new BehaviorSubject<number>(0);
    public course$ = this.courseId$.pipe(
        switchMap((id) => {
                if (id == 0)
                    return of({});

                var url = `${this.API_URL}/courses/${id}`
                return this.http.get<any>(url).pipe(
                    tap(() => {
                        this.log('course', 'Fetched a single course from a request for current user', LogCategory.SubscriptionData);
                    }),
                    shareReplay(1)
                );
        })
    )
       
    //Update or create a request
    public saveRequest(request: any): Observable<any> {
                
        var url = `${this.API_URL}/${request.RequestId}`;
        this.hasSaveError = false;
        this.saveStatus$.next('Saving...');
        return this.http.put(url, request, this.httpOptions);
    }

    public submitDrafts$(): Observable<any> {
        let url = `${this.API_URL}/drafts`;
        this.hasSaveError = false;
        this.saveStatus$.next('Saving...');
        return this.http.put(url, null).pipe(
            tap((res) => {
                if (res.SuccessCount == 0)
                    this.toastr.error('Current drafts missing too much information to be submitted.');
                else {
                    this.toastr.success(`${res.SuccessCount} draft${res.SuccessCount > 1 ? 's' : ''} successfully submitted.`);
                    this.refreshSubject$.next(true);
                }
            })
        );
    }

    private _lookups$: Observable<any>;
    public get lookups$(): Observable<any> {
        if (this._lookups$ == null) {
            var url = `${this.API_URL}/lookups`
            this._lookups$ = this.http.get(url).pipe(               
                shareReplay(1)
            );
        }
        return this._lookups$;
    }

    public preApprovals$: Observable<any[]> = this.http.get<any[]>(`${this.API_URL}/courses`).pipe(
        tap((data: any[]) => {
            this.log('preApprovals', 'Fetched all pre-approved courses', LogCategory.SubscriptionData);
        }),
        shareReplay(1)
    );

    //#region pre-approval filters
    public countries$ = this.preApprovals$.pipe(
        map((approvals: any[]) => [...new Set(approvals.map(course => course.HostCountry))]
            .filter(country => country)
            .sort((a, b) => a.localeCompare(b))
        )
    );

    public institutions$ = this.preApprovals$.pipe(
        map((approvals: any[]) => [...new Set(approvals.map(course => course.HostProgram))]
            .filter(inst => inst)
            .sort((a, b) => a.localeCompare(b))
        )
    );

    public depts$ = this.preApprovals$.pipe(
        map((approvals: any[]) =>
            [...new Set(
                approvals
                    .map(course => typeof course.UncDepartment === 'string' ? course.UncDepartment.trim() : '')
                    .filter(dept => dept) // removes empty strings and nulls
            )].sort((a, b) => a.localeCompare(b))
        )
    );

    public genEds$ = this.preApprovals$.pipe(
        //  There was an entry with a space in it that was causing duplication.
        map((approvals: any[]) => {
            let ges = approvals.flatMap(a => a.GeneralEducation?.map(ge => ge.trim()) ?? [])
                .sort((a, b) => a.localeCompare(b));

            return [...new Set(ges)];
        }
        ),
    );

    public areasOfEmphasis$ = this.preApprovals$.pipe(
        map((approvals: any[]) =>
            [...new Set(
                approvals
                    .flatMap(course => Array.isArray(course.AreasOfEmphasis) ? course.AreasOfEmphasis : [])
                    .map(aoe => typeof aoe === 'string' ? aoe.trim() : aoe)
                    .filter(ae => ae != null && ae !== '')
            )]
        )
    );

    public hostCourseNumbers$ = this.preApprovals$.pipe(
        map((approvals: any[]) =>
            [...new Set(
                approvals
                    .flatMap(course => Array.isArray(course.HostCourseNumbers) ? course.HostCourseNumbers : [])
                    .map(hcn => typeof hcn === 'string' ? hcn.trim() : hcn)
                    .filter(cn => cn != null && cn !== '')
            )]
        )
    );
    //#endregion

    public updateSyllabus(data: File, requestId: number): Observable<any> {
        var url = `${this.API_URL}/${requestId}/syllabus`        
        const formData: FormData = new FormData();        
        formData.append('fileKey', data, data.name);        
               
        return this.http
            .put<any>(url, formData)
            .pipe(           
                tap(a => {                   
                this.log("updateSyllabus", "Syllabus updated.", LogCategory.SubscriptionData);                
            }))            

    }    

    public deleteDraftRequest(requestId: number, isDeleteDraftRequestRunning: any[] ) {
        return this.http
            .delete(this.API_URL + `/${requestId}`)
            .subscribe(
                (data) => {
                    this.log('deleteDraftRequest', 'delete draft request success', LogCategory.SubscriptionData);
                },
                (error) => {
                    this.log('deleteDraftRequest', 'delete draft request error', LogCategory.SubscriptionData);
                },
                () => {
                    this.log('deleteDraftRequest', 'delete draft request complete', LogCategory.SubscriptionData);
                    isDeleteDraftRequestRunning[requestId] = false;
                    this.refreshSubject$.next(true);
                }
            );;
    }

    public currentSyllabus$: BehaviorSubject<string> = new BehaviorSubject("");
    public syllabus$: Observable<any> = this.currentSyllabus$
        .pipe(
            switchMap((item) => this.http.get(`${this.API_URL}/${item}/syllabus`, { responseType: 'blob' })
                .pipe(
                    map(
                        (res: Blob) => {
                            return new Blob([res]);
                        })
                )
            ));

    public openSyllabus(id, fileName) {
        this.currentSyllabus$.next(id);
        this.syllabus$
            .pipe(
                take(1)  //  This restricts the response so it only returns the most recent item from the behavior subject
            )
            .subscribe(res => {
                var url = window.URL.createObjectURL(res);

                //  Blobs do not have file names.  This allows for an automatic download of the file while
                //  retaining the original file name.
                this.utility.downloadFile(fileName, url);
            });
    }

    public openDeleteDraftConfirmModal(request) {
        const created = new Date(request.Created?.TimeStamp).toLocaleDateString("en-US", {
            year: "2-digit",
            month: "numeric",
            day: "numeric"
        });

        const modalRefConfirm = this.modalService.open(DisplayDetailsModalComponent);
        modalRefConfirm.componentInstance.title = "Delete Draft";
        modalRefConfirm.componentInstance.body = `<div class="container">
            <div class="row col-12">
                <p><strong>Are you sure you want to delete your draft for the following class? </strong></p>
            </div>
            <div class="row justify-content-center">
                <div class="col-10">`;

        if (!!request.HostCourseName)
            modalRefConfirm.componentInstance.body += request.HostCourseName;
        if (!!request.HostCourseNumber)
            modalRefConfirm.componentInstance.body += ` (${request.HostCourseNumber})`;
        if ((!!request.HostCourseName || !!request.HostCourseNumber) && !!request.HostCreditHours)
            modalRefConfirm.componentInstance.body += `, `;
        if (!!request.HostCreditHours)
            modalRefConfirm.componentInstance.body += `${request.HostCreditHours} credits`;
        if (!!request.HostCourseName || !!request.HostCourseNumber || !!request.HostCourseNumber || !!request.HostCreditHours)
            modalRefConfirm.componentInstance.body += `<br/>`;
        if (!!request.Term)
            modalRefConfirm.componentInstance.body += `${request.Term} `;
        if (!!request.HostUniversity)
            modalRefConfirm.componentInstance.body += request.HostUniversityDisplay;
        if (!!request.Term || !!request.HostUniversity)
            modalRefConfirm.componentInstance.body += `<br/>`;
        if (!!request.UncCourse)
            modalRefConfirm.componentInstance.body += `for ${request.UncCourse}`;
        if (!!request.UncCourse && !!request.UncCourseHours)
            modalRefConfirm.componentInstance.body += `,`;
        if (!!request.UncCourseHours)
            modalRefConfirm.componentInstance.body += ` ${request.UncCourseHours} credits`;
        if (!!request.UncCourse || !!request.UncCourseHours)
            modalRefConfirm.componentInstance.body += `<br/>`;

        modalRefConfirm.componentInstance.body += `<span>Created - ${created} <br /></span>
                </div>
            </div>
            <div class="row col-12">
                <p><strong>This operation can not be undone.</strong></p>
            </div>
        </div>`;
        modalRefConfirm.componentInstance.okButton = "Delete";
        modalRefConfirm.componentInstance.useTwoButtons = true;
        modalRefConfirm.componentInstance.useDangerColor = true;

        return modalRefConfirm;
    }
}

export interface IRequest {
    Term: string;
    HostUniversity: string;
    HostCourseName: string;
    HostCourseNumber: string;
    HostCreditHours: number;
    UncCourse: string;
    UncCourseHours: number;
    Created: string;

}
